import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ingest" }
const _hoisted_2 = {
  key: 0,
  class: "credentials"
}
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { class: "info" }
const _hoisted_12 = {
  key: 1,
  class: "no-credentials"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Copy = _resolveComponent("Copy")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_Popconfirm = _resolveComponent("Popconfirm")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode(" Loading"),
            _createElementVNode("br", null, null, -1 /* HOISTED */),
            _createTextVNode("Please wait... ")
          ])),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createBlock(_component_SettingsFrame, {
          key: 1,
          title: "External Files Bucket",
          description: "Connect to ingest bucket and share external files between all users."
        }, {
          default: _withCtx(() => [
            ($options.have_certs)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[12] || (_cache[12] = _createElementVNode("span", null, "Client Certificate:", -1 /* HOISTED */)),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    _cache[14] || (_cache[14] = _createElementVNode("span", null, "***************", -1 /* HOISTED */)),
                    _createVNode(_component_Copy, {
                      size: "1.6rem",
                      onCopy: _cache[0] || (_cache[0] = $event => (_ctx.$utils.copyText($options.ingest_cert)))
                    }),
                    _createVNode(_component_Icon, {
                      class: "icon",
                      icon: "download-02",
                      width: "1.6rem",
                      height: "1.6rem",
                      onClick: _cache[1] || (_cache[1] = $event => ($options.stringToFile($options.ingest_cert, 'client.pem')))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[15] || (_cache[15] = _createElementVNode("span", null, "Certificate Public Key:", -1 /* HOISTED */)),
                    _cache[16] || (_cache[16] = _createTextVNode()),
                    _cache[17] || (_cache[17] = _createElementVNode("span", null, "***************", -1 /* HOISTED */)),
                    _createVNode(_component_Copy, {
                      size: "1.6rem",
                      onCopy: _cache[2] || (_cache[2] = $event => (_ctx.$utils.copyText($options.ingest_pubkey)))
                    }),
                    _createVNode(_component_Icon, {
                      class: "icon",
                      icon: "download-02",
                      width: "1.6rem",
                      height: "1.6rem",
                      onClick: _cache[3] || (_cache[3] = $event => ($options.stringToFile($options.ingest_pubkey, 'client.pubkey.pem')))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "Certificate Private Key:", -1 /* HOISTED */)),
                    _cache[19] || (_cache[19] = _createTextVNode()),
                    _cache[20] || (_cache[20] = _createElementVNode("span", null, "***************", -1 /* HOISTED */)),
                    _createVNode(_component_Copy, {
                      size: "1.6rem",
                      onCopy: _cache[4] || (_cache[4] = $event => (_ctx.$utils.copyText($options.ingest_privkey)))
                    }),
                    _createVNode(_component_Icon, {
                      class: "icon",
                      icon: "download-02",
                      width: "1.6rem",
                      height: "1.6rem",
                      onClick: _cache[5] || (_cache[5] = $event => ($options.stringToFile($options.ingest_privkey, 'client.key')))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "Private Key Passphrase:", -1 /* HOISTED */)),
                    _cache[22] || (_cache[22] = _createTextVNode()),
                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "***************", -1 /* HOISTED */)),
                    _createVNode(_component_Copy, {
                      size: "1.6rem",
                      onCopy: _cache[6] || (_cache[6] = $event => (_ctx.$utils.copyText($options.ingest_pass)))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[24] || (_cache[24] = _createElementVNode("span", null, "Certificate Valid To:", -1 /* HOISTED */)),
                    _cache[25] || (_cache[25] = _createTextVNode()),
                    _createElementVNode("span", null, _toDisplayString($options.ingest_valid_to), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[26] || (_cache[26] = _createElementVNode("span", null, "Bucket Name:", -1 /* HOISTED */)),
                    _cache[27] || (_cache[27] = _createTextVNode()),
                    _createElementVNode("span", null, _toDisplayString($options.bucket_name), 1 /* TEXT */),
                    _createVNode(_component_Copy, {
                      size: "1.6rem",
                      onCopy: _cache[7] || (_cache[7] = $event => (_ctx.$utils.copyText($options.bucket_name)))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[28] || (_cache[28] = _createElementVNode("span", null, "Role ARN:", -1 /* HOISTED */)),
                    _cache[29] || (_cache[29] = _createTextVNode()),
                    _createElementVNode("span", null, _toDisplayString($options.role_arn), 1 /* TEXT */),
                    _createVNode(_component_Copy, {
                      size: "1.6rem",
                      onCopy: _cache[8] || (_cache[8] = $event => (_ctx.$utils.copyText($options.role_arn)))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[30] || (_cache[30] = _createElementVNode("span", null, "Trust Anchor ARN:", -1 /* HOISTED */)),
                    _cache[31] || (_cache[31] = _createTextVNode()),
                    _createElementVNode("span", null, _toDisplayString($options.ta_arn), 1 /* TEXT */),
                    _createVNode(_component_Copy, {
                      size: "1.6rem",
                      onCopy: _cache[9] || (_cache[9] = $event => (_ctx.$utils.copyText($options.ta_arn)))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[32] || (_cache[32] = _createElementVNode("span", null, "Profile ARN:", -1 /* HOISTED */)),
                    _cache[33] || (_cache[33] = _createTextVNode()),
                    _createElementVNode("span", null, _toDisplayString($options.profile_arn), 1 /* TEXT */),
                    _createVNode(_component_Copy, {
                      size: "1.6rem",
                      onCopy: _cache[10] || (_cache[10] = $event => (_ctx.$utils.copyText($options.profile_arn)))
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_Popconfirm, {
                      width: "max-content",
                      "confirm-button-text": "Yes",
                      "cancel-button-text": "No",
                      title: "Recreate Ingest Credentials?",
                      disabled: $data.loading,
                      onConfirm: _ctx.onRecreateIngestCreds
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Button, {
                          small: "",
                          disabled: $data.loading,
                          onClick: $options.onCreate
                        }, {
                          default: _withCtx(() => _cache[34] || (_cache[34] = [
                            _createTextVNode("Recreate Credentials")
                          ])),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled", "onClick"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled", "onConfirm"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[36] || (_cache[36] = _createElementVNode("div", null, "No ingest bucket credentials available", -1 /* HOISTED */)),
                  _createVNode(_component_Button, {
                    small: "",
                    onClick: $options.onCreate
                  }, {
                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                      _createTextVNode("Create Credentials")
                    ])),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]))
          ]),
          _: 1 /* STABLE */
        }))
  ]))
}